/** Е-Собес пока только на тесте: флаг задаётся при сборке фронта. */
export const ESOBES_ENABLED = process.env.REACT_APP_ESOBES_ENABLED === "true";

export type EsobesSendStatus = "SENT" | "ERROR" | "SKIPPED" | "PENDING";

export type EsobesStatusFilter = "" | "SENT" | "ERROR" | "SKIPPED";

export type EsobesSettings = {
  orgCode?: string;
  serviceCode?: string;
  regionKato?: string;
  signData?: boolean;
  placeholders?: boolean;
};

export type EsobesBatchStart = {
  batchId: string | number;
};

export type EsobesBatch = {
  batchId: string | number;
  reportId?: number;
  reportNumber?: string;
  total?: number;
  sent?: number;
  failed?: number;
  skipped?: number;
  pending?: number;
  status?: string;
  startedAt?: string;
  finishedAt?: string;
};

export type EsobesSend = {
  id: string | number;
  batchId?: string | number;
  reportId?: number;
  reportNumber?: string;
  studentId?: number;
  iinMasked?: string;
  fio?: string;
  appId?: number;
  payId?: number;
  status?: string;
  code?: string;
  nameRu?: string;
  message?: string;
  messageId?: string;
  sentAt?: string;
};

export type EsobesSendQuery = {
  reportId?: string;
  status?: string;
  iin?: string;
  page: number;
  size: number;
};

export type EsobesSendPage = {
  content?: EsobesSend[];
  totalElements?: number;
};

export const ESOBES_STATUS_FILTERS: { value: EsobesStatusFilter; label: string }[] = [
  { value: "", label: "Все" },
  { value: "SENT", label: "Передано" },
  { value: "ERROR", label: "Ошибка" },
  { value: "SKIPPED", label: "Пропущено" },
];
